export default interface WorkflowStatus {
  name: string;
  readOnly: boolean;
  deleted: boolean;
  id: number;
}

export const workflowStatusDefaultProps: WorkflowStatus = {
  name: "Összes",
  readOnly: true,
  deleted: false,
  id: 1,
};
